export const environment = {
  production: false,
  panel: "ls_",
  domain: "bingobook247.com",
  baseUrl: "https://api.bingobook247.com",
  trafficTag: '',
  isMobile: true,
  ludoGameId: '1521',
  demoLoginUserName: 'demo123',
  isBetOpenEnv: false,
  pollers: {
    oddsData: 600,
    listOddsData: 10000,
    scoresData: 1000,
  },
  noDataMsg: 'No Data Found',
  eventHighLight: [28569726],
  imgPrefix: '/king_client',
  guestEnable: false,
  mobileWidth: 768,
  wpLinkShowPages: '/sports, /home, /inplay',
  demoDWLink: '',
  apiWpLink: '',
  stakes: { "stake_name_1": "100", "stake_name_2": "5000", "stake_name_3": "500", "stake_name_4": "25000", "stake_name_5": "50000", "stake_name_6": "100000", "stake_name_7": "500000", "stake_name_8": "1000000", "stake_amount_1": 100, "stake_amount_2": 5000, "stake_amount_3": 500, "stake_amount_4": 25000, "stake_amount_5": 50000, "stake_amount_6": 100000, "stake_amount_7": 500000, "stake_amount_8": 1000000 },
  horseRaceJockeyImgPrefix: 'https://content-cache.cdnbf.net/feeds_images/Horses/SilkColours/',
  host: {
    domain: '',
    apiDomain: '',
    name: '',
    dName: '',
    ext: '',
    theme: '',
    email: '',
    social: {
      isShow: false,
      whatsApp: '',
      instagram: '',
      telegram: ''
    },
    pusher: {
      key: '',
      cluster: ''
    },
    ftLivetvData:'',
    guestEnable: false,
    demoLoginWpLink: '',
    wpLink: '',
    forgotWaLink: '',
    depoWithdraw: false,
    downloadApk: '',
    themePath: ['assets/css/theme-master.css'],
    iframeDomainUrl: '',
    signUpActive: false,
    demoDepoWithdrawLink: '',
    footer: {
      isShow: true,
    },
    afterLoginNoticePath: '',
    chatScript: {
      src: '',
      attr: {},
      id: '',
      username: '',
      // name: ''
    },
  },
  hosts: [
    {
      domain: 'localhost',
      apiDomain: 'localhost',
      name: 'localhost',
      dName: 'LocalHost',
      ext: '.com',
      theme: 'blue-body',
      email: 'testemail@gmail.com',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '057170df2af18ee833fc',
        cluster: 'ap2'
      },
      ftLivetvData:'',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: 'https://wa.link/reddycard',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://dada247.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'bingobook247.com',
      apiDomain: 'bingobook247.com',
      name: 'bingobook247',
      dName: 'bingobook247',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: false,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'laser247.global',
      apiDomain: 'alexisly.com',
      name: 'laser247',
      dName: 'laser247',
      ext: '.global',
      theme: 'yellow-body',
      email: 'laser247win@gmail.com',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: 'https://awl247wa.com/casino/laser247',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: 'https://allwhitelabel247.com/Laser247.apk',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: 'https://go.wa.link/laser247official',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-laser-apk-download2026.webp',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'dwarkesh.club',
      apiDomain: 'dwarkesh.club',
      name: 'dwarkesh',
      dName: 'dwarkesh',
      ext: '.club',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'laser247.company',
      apiDomain: 'laser247.company',
      name: 'laser247',
      dName: 'laser247',
      ext: '.company',
      theme: 'yellow-body',
      email: 'laser247win@gmail.com',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: false,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: false,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'kuttiexchange.com',
      apiDomain: 'kuttiexchange.com',
      name: 'kuttiexchange',
      dName: 'kuttiexchange',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: true,
        whatsApp: 'https://wa.link/kuttiexchange',
        instagram: 'https://www.instagram.com/kuttyexchange247?igsh=d3NzOXM2bnF5MWVr',
        telegram: 't.me/Kuttyexchange'
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: 'https://github.com/1xbetfair/laser247/releases/download/v1.1/new-Laser247.apk',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'hunkexchange.com',
      apiDomain: 'hunkexchange.com',
      name: 'hunkexchange',
      dName: 'hunkexchange',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: true,
        whatsApp: 'https://wauser.link/jsrcustomercare',
        instagram: 'https://www.instagram.com/jsrbookofficial',
        telegram: 'https://t.me/+Z1MYiWo0NukzZWI1'
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      guestEnable: true,
      demoLoginWpLink: 'https://wauser.link/jsrcustomercare',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: false,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'astronexch.com',
      apiDomain: 'astronexch.com',
      name: 'astronexch',
      dName: 'astronexch',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-yellow.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'bookbaazaar.com',
      apiDomain: 'bookbaazaar.com',
      name: 'bookbaazaar',
      dName: 'bookbaazaar',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: true,
        whatsApp: 'https://wa.link/bookbaazaar',
        instagram: 'https://www.instagram.com/bookbaazaarofficial',
        telegram: 'https://t.me/bookbaazaar'
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-yellow.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'funplay247.com',
      apiDomain: 'funplay247.com',
      name: 'funplay247',
      dName: 'funplay247',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '961c82bb314d3e5f22b5',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: '11starexch.com',
      apiDomain: '11starexch.com',
      name: '11starexch',
      dName: '11starexch',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '961c82bb314d3e5f22b5',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-yellow.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'mahakallive.com',
      apiDomain: 'mahakallive.com',
      name: 'mahakallive',
      dName: 'mahakallive',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '961c82bb314d3e5f22b5',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-yellow.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'm247.co',
      apiDomain: 'm247.co',
      name: 'm247',
      dName: 'm247',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '30d84d922854368d449e',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://77panel.co/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'swamiguru.com',
      apiDomain: 'swamiguru.com',
      name: 'swamiguru',
      dName: 'swamiguru',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-yellow.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'lionexchange247.in',
      apiDomain: 'lionexchange247.in',
      name: 'lionexchange247',
      dName: 'lionexchange247',
      ext: '.in',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: 'https://github.com/1xbetfair/laser247/releases/download/v1.1/new-Laser247.apk',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'lionexch247.com',
      apiDomain: 'lionexch247.com',
      name: 'lionexch247',
      dName: 'lionexch247',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: 'https://allwhitelabel247.com/Laser247.apk',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/apk-download.webp',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'kesar365.com',
      apiDomain: 'kesar365.com',
      name: 'kesar365',
      dName: 'kesar365',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: 'fdf9a08dc1f2bfa9cffa',
        cluster: 'eu'
      },
      ftLivetvData:'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      guestEnable: true,
      demoLoginWpLink: 'https://wa.link/247support',
      wpLink: 'https://wa.link/247support',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'skybook99.com',
      apiDomain: 'skybook99.com',
      name: 'skybook99',
      dName: 'skybook99',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: 'fdf9a08dc1f2bfa9cffa',
        cluster: 'eu'
      },
      ftLivetvData:'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: '',
      signUpActive: false,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: '1xfairplay.com',
      apiDomain: '1xfairplay.com',
      name: '1xfairplay',
      dName: '1xfairplay',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: 'https://go.wa.link/1xfairplay',
      wpLink: 'https://bio.wa.link/1xfairplay',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-mycric77-1xfairplay.webp',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'paree247.com',
      apiDomain: 'paree247.com',
      name: 'paree247',
      dName: 'paree247',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: true,
        whatsApp: 'https://wa.me//+919727651846',
        instagram: 'https://www.instagram.com/official_paree247?igsh=MWp4cHN1YnBlcjMwZw==',
        telegram: 'https://t.me/Paree247'
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: 'https://wa.me//+919727651846',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-yellow-black.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'laser999.in',
      apiDomain: 'laser999.in',
      name: 'laser999',
      dName: 'laser999',
      ext: '.in',
      theme: 'yellow-body',
      email: 'laser247win@gmail.com',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: false,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: false,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'reddyanna.page',
      apiDomain: 'reddyanna.page',
      name: 'reddyanna',
      dName: 'reddyanna',
      ext: '.page',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: false,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'reddyanna321.com',
      apiDomain: 'reddyanna321.com',
      name: 'reddyanna321',
      dName: 'reddyanna321',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: false,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'laser999.org',
      apiDomain: 'laser999.org',
      name: 'laser999',
      dName: 'laser999',
      ext: '.org',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: 'https://wa.link/tradeexchange96',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: false,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'khelo-bindas.com',
      apiDomain: 'khelo-bindas.com',
      name: 'khelobindas',
      dName: 'khelobindas',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-brown.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'swastik365.in',
      apiDomain: 'swastik365.in',
      name: 'swastik365',
      dName: 'swastik365',
      ext: '.in',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-blue.css'],
      iframeDomainUrl: 'https://77panel.co/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'swastik365.io',
      apiDomain: 'swastik365.io',
      name: 'swastik365',
      dName: 'swastik365',
      ext: '.io',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://77panel.co/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-iccwwc-fifa2026.webp',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'theviratexchange247.com',
      apiDomain: 'theviratexchange247.com',
      name: 'theviratexchange247',
      dName: 'theviratexchange247',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: 'https://awl247wa.com/business/viratexch247',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: 'https://allwhitelabel247.com/ViratExchange.apk',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/ipl2026-popup.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'reddyanna.ltd',
      apiDomain: 'reddyanna.ltd',
      name: 'reddyanna',
      dName: 'reddyanna',
      ext: '.ltd',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: 'https://w.app/-reddyannaofficial',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: false,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'shreenathexch.com',
      apiDomain: 'shreenathexch.com',
      name: 'shreenathexch',
      dName: 'shreenathexch',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '30d84d922854368d449e',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://77panel.co/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'crick365.win',
      apiDomain: 'crick365.win',
      name: 'crick365',
      dName: 'crick365',
      ext: '.win',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '957d2dd7ae5f87661d90',
        cluster: 'eu'
      },
      ftLivetvData:'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: '',
      signUpActive: false,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'thala247.io',
      apiDomain: 'alexisly.com',
      name: 'thala247',
      dName: 'thala247',
      ext: '.io',
      theme: 'yellow-body',
      email: 'laser247win@gmail.com',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: 'https://allwhitelabel247.com/Laser247.apk',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'mycircle365.site',
      apiDomain: 'mycircle365.site',
      name: 'mycircle365',
      dName: 'mycircle365',
      ext: '.site',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '30d84d922854368d449e',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://77panel.co/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/laser-v8/landing/popup-new.jpg',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'vishnugaming33.com',
      apiDomain: 'vishnugaming33.com',
      name: 'vishnugaming33',
      dName: 'vishnugaming33',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '957d2dd7ae5f87661d90',
        cluster: 'eu'
      },
      ftLivetvData:'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: '',
      signUpActive: false,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'royalgame444.com',
      apiDomain: 'royalgame444.com',
      name: 'royalgame444',
      dName: 'royalgame444',
      ext: '.com',
      theme: 'yellow-body',
      email: '',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '957d2dd7ae5f87661d90',
        cluster: 'eu'
      },
      ftLivetvData:'https://e765432.xyz/static/cc6c487c44b971286c3d0d1e24649619b4681674/getdata.php?chid=',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: '',
      signUpActive: false,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'mylaser247.site',
      apiDomain: 'alexisly.com',
      name: 'mylaser247',
      dName: 'mylaser247',
      ext: '.site',
      theme: 'yellow-body',
      email: 'laser247win@gmail.com',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: 'https://awl247wa.com/casino/laser247',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: 'https://allwhitelabel247.com/Laser247.apk',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: 'https://awl247wa.com/casino/laser247',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-laser-apk-download2026.webp',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'mylaser247.my',
      apiDomain: 'alexisly.com',
      name: 'mylaser247',
      dName: 'mylaser247',
      ext: '.my',
      theme: 'yellow-body',
      email: 'laser247win@gmail.com',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: 'https://awl247wa.com/casino/laser247',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: 'https://allwhitelabel247.com/Laser247.apk',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://99h.biz/',
      signUpActive: true,
      demoDepoWithdrawLink: 'https://awl247wa.com/casino/laser247',
      footer: {
        isShow: true,
      },
      afterLoginNoticePath: 'https://sthiracdn.com/assets/popup/popup-laser-apk-download2026.webp',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'rolex21.pro',
      apiDomain: 'alexisly.com',
      name: 'rolex21',
      dName: 'rolex21',
      ext: '.pro',
      theme: 'yellow-body',
      email: 'laser247win@gmail.com',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: 'https://wa.me/message/TGD6T5S2S2QEN1avu',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
    {
      domain: 'lasser999.com',
      apiDomain: 'alexisly.com',
      name: 'lasser999',
      dName: 'lasser999',
      ext: '.com',
      theme: 'yellow-body',
      email: 'laser247win@gmail.com',
      social: {
        isShow: false,
        whatsApp: '',
        instagram: '',
        telegram: ''
      },
      pusher: {
        key: '76d7c55c2b5f8747ffd4',
        cluster: 'eu'
      },
      ftLivetvData:'https://premiumodds.cc/score/f50d78a6b623eb7d72eb4bf79800e0217e6b401d/',
      guestEnable: true,
      demoLoginWpLink: '',
      wpLink: '',
      forgotWaLink: '',
      depoWithdraw: true,
      downloadApk: '',
      themePath: ['assets/css/theme-master.css'],
      iframeDomainUrl: 'https://panel.freeplay24.com/',
      signUpActive: true,
      demoDepoWithdrawLink: '',
      footer: {
        isShow: false,
      },
      afterLoginNoticePath: '',
      chatScript: {
        src: '',
        attr: {},
        id: '',
        username: '',
        // name: ''
      },
    },
  ]
};
